import { type Control, useFormState, useWatch } from 'react-hook-form';
import { Stack, Grid, Typography, Divider, Box } from '@mui/material';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';

import { type EditAuditFormBackgroundData } from '#apps/client-web/pages/audit-form-background/types';
import { getSuiteTypeLabel } from '#apps/client-web/features/audit-form-mechanical/constants';

export type MurbSuitesDetailsProps = {
  control: Control<EditAuditFormBackgroundData>;
};

export const MurbSuitesDetails = ({ control }: MurbSuitesDetailsProps) => {
  const { errors } = useFormState({ control });

  const { general: { murbSuites } = {} } = useWatch({ control });

  const count = murbSuites?.length ?? 0;
  const hasError = !!errors.general?.murbSuites;

  return (
    <Box sx={{ width: '100%' }}>
      <Stack spacing={1}>
        <Typography
          component="div"
          variant="body2"
          color="textSecondary"
          sx={{ mb: 0.5 }}>
          <Grid container alignItems="center">
            <MeetingRoomIcon fontSize="inherit" />
            <span>&nbsp;MURB Suites</span>
          </Grid>
        </Typography>
        <Grid container justifyContent="space-between">
          <Typography component="span" variant="body2">
            Count:
          </Typography>
          <Typography
            component="span"
            variant="body2"
            color={
              hasError ? 'error' : count === 0 ? 'textDisabled' : 'textPrimary'
            }>
            {count === 0
              ? 'No suites added'
              : `${count} suite${count !== 1 ? 's' : ''}`}
          </Typography>
        </Grid>
        {count > 0 && (
          <Grid container justifyContent="space-between">
            <Typography component="span" variant="body2">
              Types:
            </Typography>
            <Typography component="span" variant="body2" color="textPrimary">
              {[
                ...new Set(
                  murbSuites
                    ?.map((s) => getSuiteTypeLabel(s.type ?? 0))
                    .filter(Boolean),
                ),
              ].join(', ')}
            </Typography>
          </Grid>
        )}
        <Divider />
      </Stack>
    </Box>
  );
};
